/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Sync sticky add-to-cart button with main button
 */
(function() {
  'use strict';

  function syncStickyButton() {
    var mainButton = document.querySelector('.ProductForm__AddToCart:not(.ProductForm__StickyAddToCart)');
    var stickyButton = document.querySelector('.ProductForm__StickyAddToCart');

    if (!mainButton || !stickyButton) {
      return;
    }

    // Sync classes
    stickyButton.className = mainButton.className;

    // Sync attributes
    stickyButton.setAttribute('data-use-primary-button', mainButton.getAttribute('data-use-primary-button') || 'false');
    
    if (mainButton.hasAttribute('data-action')) {
      stickyButton.setAttribute('data-action', mainButton.getAttribute('data-action'));
    } else {
      stickyButton.removeAttribute('data-action');
    }

    if (mainButton.hasAttribute('disabled')) {
      stickyButton.setAttribute('disabled', 'disabled');
    } else {
      stickyButton.removeAttribute('disabled');
    }

    // Sync innerHTML
    stickyButton.innerHTML = mainButton.innerHTML;
  }

  // Sync on variant change
  document.addEventListener('variant:changed', function() {
    // Use a small delay to ensure the main button has been updated
    setTimeout(syncStickyButton, 50);
  });

  // Sync on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncStickyButton);
  } else {
    syncStickyButton();
  }

  // Sync when main button is clicked (for loading state)
  document.addEventListener('click', function(event) {
    if (event.target.closest('.ProductForm__AddToCart:not(.ProductForm__StickyAddToCart)')) {
      setTimeout(syncStickyButton, 10);
    }
  });

  // Sync when product is added (to restore button state)
  document.addEventListener('product:added', function() {
    setTimeout(syncStickyButton, 100);
  });

  /**
   * Sync sticky variant selector with main variant selector
   */
  function syncStickyVariantSelector() {
    var stickyVariantSelector = document.querySelector('.ProductForm__Option--sticky');
    if (!stickyVariantSelector) {
      return;
    }

    // Find the corresponding main variant selector
    var mainVariantSelectors = document.querySelectorAll('.ProductForm__Option:not(.ProductForm__Option--sticky)');
    if (mainVariantSelectors.length === 0) {
      return;
    }

    // Get the first option (we only show the first option in sticky area)
    var mainFirstOption = mainVariantSelectors[0];
    var mainSelectedValue = mainFirstOption.querySelector('.ProductForm__SelectedValue');
    
    if (mainSelectedValue) {
      var stickySelectedValue = stickyVariantSelector.querySelector('.ProductForm__SelectedValue');
      if (stickySelectedValue) {
        stickySelectedValue.innerHTML = mainSelectedValue.innerHTML;
      }

      // Update the selected state in the popover
      var stickyPopover = stickyVariantSelector.querySelector('.OptionSelector--sticky');
      if (stickyPopover) {
        var stickyValues = stickyPopover.querySelectorAll('.Popover__Value');
        var mainValues = mainFirstOption.querySelectorAll('.Popover__Value');
        
        stickyValues.forEach(function(stickyValue, index) {
          if (mainValues[index] && mainValues[index].classList.contains('is-selected')) {
            stickyValue.classList.add('is-selected');
          } else {
            stickyValue.classList.remove('is-selected');
          }
        });
      }
    }
  }

  // Sync variant selector on variant change
  document.addEventListener('variant:changed', function() {
    setTimeout(function() {
      syncStickyVariantSelector();
      syncStickyButton();
    }, 50);
  });

  // Sync on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncStickyVariantSelector);
  } else {
    syncStickyVariantSelector();
  }

  // Ensure sticky variant selector changes update the main form
  document.addEventListener('click', function(event) {
    var stickyValueButton = event.target.closest('.OptionSelector--sticky .Popover__Value');
    if (stickyValueButton) {
      // Find the corresponding main variant selector value and trigger it
      var optionPosition = stickyValueButton.getAttribute('data-option-position');
      var value = stickyValueButton.getAttribute('data-value');
      
      if (optionPosition && value) {
        var mainValueButton = document.querySelector('.ProductForm__Option:not(.ProductForm__Option--sticky) .Popover__Value[data-option-position="' + optionPosition + '"][data-value="' + value + '"]');
        if (mainValueButton) {
          // Trigger click on main button to update the form
          mainValueButton.click();
        }
      }
    }
  });
})();